import { FC, ReactElement } from 'react';
import { Flex, GridItem, GridItemProps } from '@chakra-ui/react';

import webView from 'common/webView';
import ProgressBar from 'components/_core/ProgressBar';
import { MicroEstimationStepProgress } from 'features/Accounting/pages/Estimation/flows/microEstimation/machine';
import zIndices from 'theme/foundations/zIndex';

import { FOOTER_GRID_AREA } from '../../constants';
import { FooterButtonProps } from '../FooterButton';

interface FooterProps extends GridItemProps {
  stepProgress: MicroEstimationStepProgress;
  children: ReactElement<FooterButtonProps>;
}

const Footer: FC<FooterProps> = ({
  children,
  stepProgress,
  ...gridItemProps
}) => {
  const { isInWebView } = webView;

  if (isInWebView) {
    return (
      <GridItem
        backgroundColor="white"
        bottom={0}
        paddingBottom="space-20"
        paddingTop="space-16"
        paddingX="space-16"
        position="sticky"
        zIndex={zIndices.sticky}
        {...gridItemProps}
        gridArea={FOOTER_GRID_AREA}
      >
        {children}
      </GridItem>
    );
  }

  return (
    <GridItem
      paddingTop="space-16"
      {...gridItemProps}
      gridArea={FOOTER_GRID_AREA}
    >
      <ProgressBar ratio={stepProgress.current / stepProgress.total} />

      <Flex justifyContent="flex-end" padding="space-16">
        {children}
      </Flex>
    </GridItem>
  );
};

export default Footer;
